const productionUrl = "https://app.superlook.ai/login";

export const redirectionFn = () => {
  const params = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();

  for (const [key, value] of params.entries()) {
    if (key.startsWith("utm_")) {
      utmParams.append(key, value);
    }
  }

  const redirectUrl = utmParams.toString()
    ? `${productionUrl}?${utmParams.toString()}`
    : productionUrl;

  window.location.href = redirectUrl;
};
